/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown> }} Wrapped_Streak_CountInputs */

const en_us2_wrapped_streak_count = /** @type {(inputs: Wrapped_Streak_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 week in a row`);
	return /** @type {LocalizedString} */ (`${i?.weeks} weeks in a row`)
	
};

const pt_br2_wrapped_streak_count = /** @type {(inputs: Wrapped_Streak_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 semana seguida`);
	return /** @type {LocalizedString} */ (`${i?.weeks} semanas seguidas`)
	
};

const es_419_wrapped_streak_count = /** @type {(inputs: Wrapped_Streak_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 semana seguida`);
	return /** @type {LocalizedString} */ (`${i?.weeks} semanas seguidas`)
	
};

const pt_pt2_wrapped_streak_count = /** @type {(inputs: Wrapped_Streak_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 semana seguida`);
	return /** @type {LocalizedString} */ (`${i?.weeks} semanas seguidas`)
	
};

const fr_fr2_wrapped_streak_count = /** @type {(inputs: Wrapped_Streak_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 semaine d'affilée`);
	return /** @type {LocalizedString} */ (`${i?.weeks} semaines d'affilée`)
	
};

const de_de2_wrapped_streak_count = /** @type {(inputs: Wrapped_Streak_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 Woche am Stück`);
	return /** @type {LocalizedString} */ (`${i?.weeks} Wochen am Stück`)
	
};

const it_it2_wrapped_streak_count = /** @type {(inputs: Wrapped_Streak_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 settimana di fila`);
	return /** @type {LocalizedString} */ (`${i?.weeks} settimane di fila`)
	
};

/**
* | weeks | output |
* | --- | --- |
* | "1" | "1 week in a row" |
* | * | "{weeks} weeks in a row" |
*
* @param {Wrapped_Streak_CountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_streak_count = /** @type {((inputs: Wrapped_Streak_CountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Streak_CountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_streak_count(inputs)
	if (locale === "es-419") return es_419_wrapped_streak_count(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_streak_count(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_streak_count(inputs)
	if (locale === "de-DE") return de_de2_wrapped_streak_count(inputs)
	if (locale === "it-IT") return it_it2_wrapped_streak_count(inputs)
	return en_us2_wrapped_streak_count(inputs)
});
export { wrapped_streak_count as "wrapped.streak_count" }